import { useState, useEffect, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './navbar.css';

const coreServices = [
  { path: '/furniture-assembly', name: 'Furniture Assembly' },
  { path: '/tv-mounting-wall-art', name: 'TV Mounting & Wall Arts'},
  { path: '/installations', name: 'Installations'},
  { path: '/carpentry', name: 'Carpentry Services' },
  { path: '/plastering-painting', name: 'Plastering & Painting' },
  { path: '/home-maintenance', name: 'Home Maintenance' },
  { path: '/commercial-maintenance', name: 'Commercial Maintenance' },
  { path: '/gardening', name: 'Outdoor & Landscaping' },
];

const Navbar = () => {

  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const menuButtonRef = useRef(null);
  const dropdownButtonRef = useRef(null);

  const toggleMenu = () => setIsOpen(!isOpen);
    
  const closeMenu = () => {
    setIsOpen(false);
    setDropdownOpen(false);
  };

  // Close dropdown if clicking outside of it
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    function handleEscape(event) {
      if (event.key === 'Escape' && (isOpen || dropdownOpen)) {
        setIsOpen(false);
        setDropdownOpen(false);
        (isOpen ? menuButtonRef : dropdownButtonRef).current?.focus();
      }
    }
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, dropdownOpen]);

  return (
      <nav className="site-navbar" aria-label="Main navigation">
      <div className="navbar-container">
        {/* Branding Logo */}
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          <img className='logo-icon' src="/static/images/branding/handyman-in-melbourne-logo.png" alt="Handyman In Melbourne logo" />
        </Link>

        {/* Mobile Hamburger Toggle */}
        <button 
          ref={menuButtonRef}
          className={`menu-toggle ${isOpen ? 'is-active' : ''}`} 
          onClick={toggleMenu}
          aria-label={isOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={isOpen}
          aria-controls="primary-navigation"
          type="button"
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        {/* Navigation Links Network */}
        <div id="primary-navigation" className={`nav-menu-wrapper ${isOpen ? 'menu-open' : ''}`}>
          <ul className="nav-links">
            <li>
              <NavLink to="/" end className={({ isActive }) => isActive ? 'nav-item active-link' : 'nav-item'} onClick={closeMenu}>
                Home
              </NavLink>
            </li>
            
            {/* Interactive Dropdown for the 9 Services */}
            <li
              className="nav-dropdown-wrapper"
              ref={dropdownRef}
              onMouseEnter={() => setDropdownOpen(true)}
              onMouseLeave={() => setDropdownOpen(false)}
              onBlur={(event) => {
                if (!event.currentTarget.contains(event.relatedTarget)) setDropdownOpen(false);
              }}
            >
              <button 
                ref={dropdownButtonRef}
                className={`nav-item dropdown-toggle-btn ${dropdownOpen ? 'active-link' : ''}`}
                onClick={() => setDropdownOpen(!dropdownOpen)}
                aria-controls="service-navigation"
                aria-expanded={dropdownOpen}
                onFocus={() => setDropdownOpen(true)}
                type="button"
              >
                Our Services <span className="arrow-down" aria-hidden="true">▼</span>
              </button>
              
              <ul id="service-navigation" className={`dropdown-menu ${dropdownOpen ? 'dropdown-visible' : ''}`}>
                {coreServices.map((service) => (
                  <li key={service.path}>
                    <NavLink to={service.path} className="dropdown-item" onClick={closeMenu}>
                      {service.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </li>

            <li>
              <NavLink to="/contact" end className={({ isActive }) => isActive ? 'nav-item active-link' : 'nav-item'} onClick={closeMenu}>
                Contact Us
              </NavLink>
            </li>
          </ul>

          {/* Primary Click-To-Call Conversion Anchor */}
          <div className="nav-cta-wrapper">
            <a href="tel:0412279273" className="nav-phone-btn">
              <span className="phone-icon" aria-hidden="true">📞</span> 0412 279 273
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
